<template>
  <q-tooltip :offset="[14, 6]" class="q-px-xs q-py-xxs radius-4">
    <slot></slot>
  </q-tooltip>
</template>

<script setup></script>
